import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'SportsActivities';

const SportsActivitiesApi: any = baseApi(endpoint);

export default SportsActivitiesApi;